import { BASE_COLUMN_TYPES, BaseColumnType } from "../../columns/config/types";
import { ReportColumnConfigBase } from "../../columns/config/ReportColumnConfig";

import {
  SalesOrderNumberColumn,
  ClientColumn,
  ProjectColumn,
  SubtotalColumn,
  OrderDateColumn,
} from "../common";

export const Columns: ReportColumnConfigBase<BaseColumnType>[] = [
  SalesOrderNumberColumn,
  ClientColumn,
  ProjectColumn,
  SubtotalColumn,
  OrderDateColumn,
];
